export default __webpack_public_path__ + "b3ef232e14796597bb6f5149223187d7.png";